import { Pressable, View, Text } from "react-native";
import { BellIcon } from "@/components/Icons";
import { colors } from "@/lib/theme";
import { useNotifications } from "@/hooks/useNotifications";

export default function NotificationBell({ onPress }: { onPress: () => void }) {
  const { unreadCount } = useNotifications();
  const display = unreadCount > 99 ? "99+" : String(unreadCount);
  return (
    <Pressable onPress={onPress} hitSlop={10} style={{ paddingHorizontal: 12, paddingVertical: 6 }}>
      <View>
        <BellIcon size={24} color={colors.ink} />
        {unreadCount > 0 && (
          <View
            style={{
              position: "absolute",
              top: -4,
              right: -6,
              minWidth: 18,
              height: 18,
              borderRadius: 9,
              backgroundColor: colors.danger,
              alignItems: "center",
              justifyContent: "center",
              paddingHorizontal: 4,
              borderWidth: 2,
              borderColor: colors.white,
            }}
          >
            <Text style={{ color: "#fff", fontSize: 10, fontWeight: "800" }}>{display}</Text>
          </View>
        )}
      </View>
    </Pressable>
  );
}
